export enum Roles {
  admin = 'administrator-neha',
  operator = 'operator',
  pharmacyOperator = 'operator-pharmacy',
  pharmacist = 'pharmacist',
  physician = 'physician',
  citizen = 'citizen',
}
